


































































































































































































import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Strike,
  Underline,
  History,
  Placeholder,
  Code
  // @ts-ignore
} from 'tiptap-extensions';
import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';

import AppDialog from '@/components/common/Dialog.vue';
import DialogContent from '@/components/common/DialogContent.vue';

@Component({
  components: {
    EditorContent,
    EditorMenuBar,
    AppDialog,
    DialogContent
  }
})
export default class RichTextArea extends Vue {
  @Prop(String)
  readonly value!: string;
  @Prop(Boolean)
  readonly disabled!: boolean;
  @Prop(String)
  readonly placeholder!: string;
  @Prop(Number)
  readonly maxLength!: number;
  @Prop({ type: String, default: '250px' })
  readonly minHeight!: string;
  @Prop(Boolean)
  readonly noResize!: boolean;
  @Prop(Number)
  readonly twoColumnBreakpoint!: number;
  @Prop(Boolean)
  readonly fullWidth!: boolean;
  @Prop(Boolean) hasError!: boolean;

  isEditorHelpDialogOpen = false;

  emitAfterOnUpdate = false;

  editor: Editor | null = null;

  extensions = [
    new Blockquote(),
    new BulletList(),
    new HardBreak(),
    new Heading({ levels: [1, 2, 3] }),
    new ListItem(),
    new OrderedList(),
    new Bold(),
    new Italic(),
    new Strike(),
    new Underline(),
    new History(),
    new Placeholder({
      showOnlycurrent: false,
      emptyNodeText: (node: any) => {
        return this.placeholder;
      }
    }),
    new Code()
  ];

  popupEditorHelp() {
    this.isEditorHelpDialogOpen = true;
  }

  closeEditorHelpDialog() {
    this.isEditorHelpDialogOpen = false;
  }

  mounted() {
    this.editor = new Editor({
      extensions: this.extensions,
      editable: !this.disabled,
      onUpdate: this.onUpdate,
      content: this.value
    });
  }

  get currentLength() {
    const htmlTagRegex = /(<([^>]+)>)/gi;
    return this.value.length ? this.value.replace(htmlTagRegex, '').length : 0;
  }

  get twoColumns() {
    return this.value ? this.value.length > this.twoColumnBreakpoint : false;
  }

  @Watch('disabled')
  onDisabledChange(val: boolean) {
    if (this.editor) {
      this.editor.setOptions({ editable: !val });
    }
  }

  @Watch('value')
  onValueChange(val: any) {
    if (this.emitAfterOnUpdate) {
      this.emitAfterOnUpdate = false;
      return;
    }

    if (this.editor) {
      this.editor.setContent(val);
    }
  }

  onUpdate(info: any) {
    this.emitAfterOnUpdate = true;
    this.$emit('change', info.getHTML());
  }

  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
}
